const modern = function () {
    /*
     * Bootstrap 4 uses:
     *   - a z-index of 1040 for its (non-stacked) modal-backdrop and
     *   - a z-index of 1050 for its (non-stacked) modal.
     *
     * Popovers (z-index 1060) and Tooltips (z-index 1070) must lie above
     * any stacked modals we create ourselves. Using a start z-index of 1050 and
     * an increment z-index of 2, this allows for a maximum of 5 stacked modals.
     * We increment the z-index of a new modal by 2 so we can put
     * an extra backdrop for the new modal at a z-index increment of 1.
     */
    const zIndexStart = 1050;
    const zIndexIncrement = 2;

    $('[widget~=dialog]').click(function () {
        $('.dialog').modal({
            show: true
        })
    });

    $(document).on('show.bs.modal', '.modal', function (event) {
        const stackDepth = $('.modal:visible').length;

        var zIndex = zIndexStart + (stackDepth * zIndexIncrement);

        $(this).css('z-index', zIndex);

        if (stackDepth === 0) return;

        $('.modal-backdrop')
            .not('.modal-stack')
            .addClass('modal-stack')
            .addClass('modal-stack-layer-' + stackDepth)
            .css('z-index', zIndex - 1);
    });

    $(document).on('hidden.bs.modal', '.modal', function (event) {
        const stackDepth = $('.modal:visible').length;

        if (stackDepth === 0) return;

        $('body').addClass('modal-open');

        $('.modal-backdrop.modal-stack-layer-' + stackDepth).remove();
    });
};

export default modern;